
  export default {
    name: "LocationsEngland",
    props: {
        all: {
            default: 'false',
            type: String,
        }
    },
    render() {
      const slot = this.$slots.default
      //  return slot.text.replace(/,/g, "")
      return slot
    }
  
  }
  